export default {
  CUSTOM_PWD_TITLE: 'User password rules',
  CUSTOM_BTN_EDIT: 'Edit',
  CUSTOM_BTN_CONFIRM: 'Confirm',
  CUSTOM_BTN_CANCEL: 'Cancel'
}
